export default __webpack_public_path__ + "static/media/component-info-2.7be953c9.png";